module.exports = __webpack_public_path__ + "img/IMG_9022_L_Wood_MockedUp.a34eab2b.jpg";